import * as React from 'react';
import * as GroupActions from '../../actions/group';
import * as UserActions from '../../actions/users';
import { RootState } from '../../reducers';
import { UserData } from '../../models/User';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import ChangeUserData from '../LoginTeacher/changeUserData';

export namespace Header {
	export interface Props extends RouteComponentProps<void> {
		user: UserData;
		userActions: typeof UserActions;
	}

	export interface State {
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export class Header extends React.Component<Header.Props, Header.State> {
	static contextTypes = {
		router: React.PropTypes.func.isRequired
	}

	constructor(props: Header.Props) {
		super(props);
	
		this.logout = this.logout.bind(this);
	}

	logout(){
		localStorage.removeItem('token');
		window.location.href = '/';
	}

	render() {
		const { user } = this.props;

		return (
			<div className="margin5">
				<img className="am_mainLogo_small" src="/images/NarrapixBetaLogo.png" />
				<div className="row">
					<div className="col-6">
						<h4 className="am_title">{user.firstname + " " + user.lastname}</h4>
					</div>
					<div className="col-6">
						<button onClick={this.logout} className="btn am_darkblue-button am_shadow margin5 float-right">KIRJAUDU ULOS</button>
						<ChangeUserData user = {this.props.user} userActions = {this.props.userActions} />
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		groupActions: bindActionCreators(GroupActions as {}, dispatch),
	};
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Common/header.tsx